import React, { useEffect, useState } from "react";
import ProfessionsAndSkills from "./components/professionsAndSkills/ProfessionsAndSkills";
import ExpertArticles from "./components/expertArticles/ExpertArticles";
import ExpertVideos from "./components/expertVideos/ExpertVideos";
import {
  getContents,
  getExpertData,
  getProfessionsAndSkills,
} from "../../service/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";

function Content() {
  const [psLoading, setPsLoading] = useState();
  const [loading, setLoading] = useState();
  const [expertData, setExpertData] = useState();
  const expertDataQuery = useQuery(["expertData"], getExpertData);
  const professionsAndSkillsQuery = useQuery(
    ["professionsAndSkills"],
    getProfessionsAndSkills
  );
  const contentsQuery = useQuery(["contents"], getContents);
  const queryClient = useQueryClient()
  useEffect(()=>{
queryClient.invalidateQueries(["contents"])
queryClient.invalidateQueries(["professionsAndSkills"])
  },[])

  useEffect(() => {
    if (expertDataQuery?.data) {
      if (expertDataQuery?.data?.modifiedExpert) {
        const mergedExpertData = expertDataQuery?.data?.expert;
        Object.entries(expertDataQuery?.data?.modifiedExpert).forEach(
          ([key, value]) => {
            if (value !== "NOT_MODIFIED") {
              mergedExpertData[key] = value;
            }
          }
        );
        setExpertData(mergedExpertData);
      }
    }
  }, [expertDataQuery?.data]);

  let professionsAndSkills = professionsAndSkillsQuery?.data;
  let articles = contentsQuery?.data?.filter(
    (content) => content.type === "ARTICLE"
  );
  let videos = contentsQuery?.data?.filter(
    (content) => content.type === "VIDEO"
  );



  return (
    <div className="p-6 max-lg:p-2 flex flex-col gap-6">
      <div>
        <ProfessionsAndSkills professionsAndSkills={professionsAndSkills} />
      </div>
      <div>
        <ExpertArticles />
      </div>
      {/* <div>
        <Education loading={loading} articles={articles} />
      </div> */}
      <div>
        <ExpertVideos loading={loading} videos={videos} />
      </div>
    </div>
  );
}

export default Content;
